exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".spectrum--large .spectrum-Link {\n  -webkit-transition: color 130ms ease-in-out;\n  transition: color 130ms ease-in-out;\n}\n", "", {"version":3,"sources":["/jenkins/workspace/CCX-Comments-Release/node_modules/@react/react-spectrum/spectrum-css/link/index-diff.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,oCAAoC;CACrC","file":"index-diff.css","sourcesContent":[".spectrum--large .spectrum-Link {\n  -webkit-transition: color 130ms ease-in-out;\n  transition: color 130ms ease-in-out;\n}\n"],"sourceRoot":""}]);

// exports
